import React from "react";

const bullets = [
  "The investment philosophy behind every Ascend opportunity",
  "Why East London & Stoke-on-Trent continue to outperform",
  "Our Buy-to-Let investment strategy explained",
  "A real investment case study with actual numbers",
  "The framework we use to assess every property",
  "How experienced investors build wealth through property",
];

export function Guide() {
  return (
    <section
      id="guide"
      data-testid="guide-section"
      className="bg-[var(--navy)] text-[var(--ivory)] grain-overlay py-24 lg:py-32"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.05fr] gap-14 lg:gap-20 items-start">
        {/* Left copy */}
        <div className="reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--gold)]" />
            <span className="text-[0.7rem] tracking-[0.34em] uppercase text-[var(--gold)]">
              Free Resource
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.75rem] leading-[1.04]">
            The UK Property
            <br /> Investor's
            <br />
            <span className="italic text-[var(--gold)]">Strategy Guide.</span>
          </h2>
          <p className="mt-8 text-[1.05rem] text-[var(--ivory)]/75 max-w-lg leading-relaxed">
            Everything you need to understand BRRR, Flips, and Buy-to-Let — written for
            investors who want to build real wealth, not just a single property.
          </p>
          <div className="mt-10">
            <p className="text-[0.7rem] tracking-[0.24em] uppercase text-[var(--gold)]/80 mb-4">
              Inside the guide
            </p>
            <ul className="space-y-3">
              {bullets.map((b, i) => (
                <li key={b} data-testid={`guide-bullet-${i}`} className="flex items-start gap-3">
                  <span className="mt-[10px] w-1.5 h-1.5 rounded-full bg-[var(--gold)] shrink-0" />
                  <span className="text-[0.98rem] text-[var(--ivory)]/85">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right form card */}
        <div className="reveal">
          <div
            data-testid="guide-form-card"
            className="bg-[var(--navy-2)] border border-[rgba(201,168,76,0.35)] p-6 sm:p-8 lg:p-10 relative"
            style={{ boxShadow: "inset 0 0 0 1px rgba(201,168,76,0.08), 0 30px 60px -30px rgba(0,0,0,0.6)" }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[var(--gold)]" />
              <span className="text-[0.7rem] tracking-[0.28em] uppercase text-[var(--gold)]">
                Request Your Copy
              </span>
            </div>
            <h3 className="font-display text-[1.7rem] leading-tight mb-2">
              An invitation to invest with intent.
            </h3>
            <p className="text-[0.92rem] text-[var(--ivory)]/65 mb-6">
              Complete the form below and we'll send your guide instantly.
            </p>

            {/*
              GHL form embed — Take Flight (new GHL account). Form ID: Bf0yTbdlNWxYZADTn5dG.
              Rendered inline; workflow trigger, "Investor Guide Lead" tag, and thank-you
              redirect are all configured inside GHL and fire regardless of layout.
            */}
            <div
              data-testid="ghl-form-embed"
              className="rounded-md overflow-hidden bg-[var(--ivory)]"
              style={{ minHeight: 480 }}
            >
              <iframe
                src="https://api.leadconnectorhq.com/widget/form/Bf0yTbdlNWxYZADTn5dG"
                style={{ width: "100%", height: "100%", minHeight: 480, border: "none", borderRadius: 4, display: "block" }}
                id="inline-Bf0yTbdlNWxYZADTn5dG"
                data-layout='{"id":"INLINE"}'
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Investment Guide Download Form"
                data-height="401"
                data-layout-iframe-id="inline-Bf0yTbdlNWxYZADTn5dG"
                data-form-id="Bf0yTbdlNWxYZADTn5dG"
                title="Investment Guide Download Form"
              />
            </div>

            <p className="mt-5 text-[0.78rem] italic text-[var(--ivory)]/55 text-center">
              We respect your privacy. Your details are held securely and never shared with third parties.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
